<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear Remision</p>
              <div class="ms-auto d-flex gap-2">
                <a v-if="form.id > 0" @click="printRemission(form.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                  style="margin-left: 15px; display: flex; align-items: center;" data-toggle="tooltip" data-original-title="Imprimir remisión">
                  <i class="fas fa-print" style="font-size: 1.2rem;"></i>
                </a>
                <argon-button v-if="(user.role != '1' && form.status === 0) || user.role === '1'" color="success"
                  size="sm" @click="save">Guardar</argon-button>
                <argon-button v-if="form.status == 0 && form.id > 0" color="success" size="sm" @click="confirm">Formalizar</argon-button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12" style="position: relative;">
                <label for="example-text-input" class="form-control-label">Cliente</label>
                <div class="d-flex gap-2 align-items-stretch">
                  <div class="flex-grow-1" style="min-width: 0;">
                    <select ref="clientSelect" class="form-control select2 w-100" style="width: 100%">
                    </select>
                  </div>
                  <argon-button color="success" size="sm" @click="openClientModal">
                    <i class="fa fa-user-plus"></i> 
                  </argon-button>
                </div>
              </div>

              <div class="col-md-6" style="display: none;">
                <label for="document-type" class="form-control-label">Tipo de Documento</label>
                <select id="documentType" class="form-control" v-model="form.document_type" :disabled="form.client_id > 0">
                  <option value="" disabled>Seleccione un tipo de documento</option>
                  <option value="CC">Cédula de Ciudadanía (CC)</option>
                  <option value="CE">Cédula de Extranjería (CE)</option>
                  <option value="TI">Tarjeta de Identidad (TI)</option>
                  <option value="RC">Registro Civil (RC)</option>
                  <option value="PA">Pasaporte (PA)</option>
                  <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                  <option value="NIT">Número de Identificación Tributaria (NIT)</option>
                </select>
              </div>

              <div class="col-md-6" style="display: none;">
                <label for="example-text-input" class="form-control-label">Número documento</label>
                <argon-input type="text" v-model="form.document" autocomplete="off" :disabled="form.client_id > 0" />
              </div>

              <div class="col-md-6" style="display: none;">
                <label for="example-text-input" class="form-control-label">Dirección</label>
                <argon-input type="text" v-model="form.address" autocomplete="off" :disabled="form.client_id > 0" />
              </div>


              <div class="col-md-6" style="display: none;">
                <label for="example-text-input" class="form-control-label">Telefono</label>
                <argon-input type="text" v-model="form.phone" :disabled="form.client_id > 0" />
              </div>

              <div class="col-md-6" style="display: none;">
                <label for="example-text-input" class="form-control-label">Email</label>
                <argon-input type="text" v-model="form.email" :disabled="form.client_id > 0" />
              </div>

              <!-- <div class="col-md-6">
                <label for="example-select-input" class="form-control-label">Seleccionar tipo</label>
                <select v-model="form.type" class="form-control">
                  <option value="production">Producción</option>
                  <option value="return">Devolución</option>
                </select>
              </div> -->

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Observación</label>
                <ArgonTextarea type="text" v-model="form.observation" />
              </div>


            </div>
          </div>
        </div>
      </div>

      <div class="col-md-10">
        <div class="card" v-if="form.id != 0">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <p class="text-uppercase mb-0">Lista de detalles</p>
              <div class="ms-auto d-flex align-items-center gap-2 flex-wrap justify-content-end">
                <argon-button v-if="user.role === '1' || user.role === '2'" variant="outline" color="secondary"
                  size="sm" type="button" @click="copyDetailsForExcel" title="Copiar ítems para Excel (orden plantilla contable)">
                  <i class="fas fa-copy" aria-hidden="true"></i>
                </argon-button>
                <argon-button v-if="user.role === '1' || user.role === '2'" color="success" size="sm"
                  @click="addDetail">Agregar producto</argon-button>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Producción</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Modelo
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Talla
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Color
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Cantidad
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Precio
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        IVA (%)</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Total
                      </th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                        v-if="(user.role !== '1' && form.status === 0) || user.role === '1'">
                        Opciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="value in data.data" :key="value.id">
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm">{{ value.production_model?.production?.name ?? value.produccion?.name ?? 'No encontrado' }}</h6>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ value.production_model?.model?.name ?? value.model?.name ?? "No encontrado" }}
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ value.production_model?.size?.size ?? 'N/A' }}
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ value.production_model?.size?.color?.name ?? 'N/A' }}
                      </td>
                      <td class="align-middle text-center">
                        <input
                          type="number"
                          min="1"
                          step="1"
                          class="form-control form-control-sm text-center"
                          style="width: 80px; margin: 0 auto;"
                          :value="value.quantity"
                          :disabled="!((user.role !== '1' && form.status === 0) || user.role === '1')"
                          @change="updateDetailQuantity(value, $event.target.value)"
                          @focus="$event.target.select()"
                        />
                      </td>

                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.price ?? 0).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) }}
                        </span>
                      </td>

                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.iva ?? 0).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) }}
                        </span>
                      </td>

                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) }}
                        </span>
                      </td>

                      <td class="align-middle text-center" v-if="user.role === '1' || user.role === '2'">

                        <a @click="editRegister(value)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                           data-toggle="tooltip" data-original-title="Editar registro">
                          <i class="fa fa-pencil-alt"></i>
                        </a>

                        <a @click="deleteRegister(value.id)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                          data-toggle="tooltip" data-original-title="Eliminar registro">
                          <i class="fa fa-trash"></i>
                        </a>
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Agregar Cliente -->
    <div class="modal fade" id="ModalClient" tabindex="-1" aria-labelledby="clientModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="clientModalLabel">Agregar Cliente</h5>
            <button type="button" class="btn-close" @click="closeClientModal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label for="client-name" class="form-label">Nombre</label>
                <input type="text" v-model="newClient.name" id="client-name" class="form-control"
                  placeholder="Ingrese el nombre del cliente" required>
              </div>
              <div class="mb-3">
                <label for="client-document-type" class="form-label">Tipo de Documento</label>
                <select id="client-document-type" class="form-select" v-model="newClient.document_type">
                  <option value="" disabled>Seleccione un tipo de documento</option>
                  <option value="CC">Cédula de Ciudadanía (CC)</option>
                  <option value="CE">Cédula de Extranjería (CE)</option>
                  <option value="TI">Tarjeta de Identidad (TI)</option>
                  <option value="RC">Registro Civil (RC)</option>
                  <option value="PA">Pasaporte (PA)</option>
                  <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                  <option value="NIT">Número de Identificación Tributaria (NIT)</option>
                </select>
              </div>
              <div class="mb-3">
                <label for="client-document" class="form-label">Número de Documento</label>
                <input type="text" v-model="newClient.document" id="client-document" class="form-control"
                  placeholder="Ingrese el número de documento" required>
              </div>
              <div class="mb-3">
                <label for="client-address" class="form-label">Dirección</label>
                <input type="text" v-model="newClient.address" id="client-address" class="form-control"
                  placeholder="Ingrese la dirección">
              </div>
              <div class="mb-3">
                <label for="client-phone" class="form-label">Teléfono</label>
                <input type="text" v-model="newClient.phone" id="client-phone" class="form-control"
                  placeholder="Ingrese el teléfono" required>
              </div>
              <div class="mb-3">
                <label for="client-email" class="form-label">Email</label>
                <input type="email" v-model="newClient.email" id="client-email" class="form-control"
                  placeholder="Ingrese el email" required>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeClientModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="saveClient">Guardar Cliente</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal agregar detalles de remision -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar producto</h5>
            <button type="button" class="btn-close" @click="submitForm" ></button>
          </div>
          <div class="modal-body">
            <form>


              <div class="mb-3">
                <label for="amount" class="form-label">Modelo</label>
                <select ref="ModelSelect" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Cantidad</label>
                <input type="text" v-model="modal.quantity" id="total_price" class="form-control"
                  placeholder="Ingrese la cantidad" @input="updateModalLineTotal" @focus="$event.target.select()">
              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="amount" class="form-label">Precio Unidad</label>
                  <input type="text" v-model="formattedPrice" id="amount" class="form-control"
                    placeholder="Ingrese el valor" @input="updateModalLineTotal">
                </div>
                <div class="col-md-6">
                  <label for="iva_percentage_remission" class="form-label">IVA (%)</label>
                  <input type="number" v-model.number="modal.iva" id="iva_percentage_remission"
                    class="form-control" min="0" max="100" step="0.01" placeholder="Ej: 19"
                    @input="updateModalLineTotal">
                </div>
              </div>
              <div class="mb-3">
                <label for="amount" class="form-label">Total</label>
                <input type="text" v-model="totalPrice" id="total_price" class="form-control"
                  placeholder="Ingrese el valor total">
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
          </div>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';
import axios from 'axios';
import authHeader from '../../../services/auth-header';


const body = document.getElementsByTagName("body")[0];

export default {
  name: "Remissions Create",
  data() {
    return {
      showMenu: false,
      modalBudget: null,
      isFinish: false,
      filter: {
        production_id: [],
        model_id: [],
        oficio_id: [],
        user_id: [],
      },
      models: [],
      user: {},
      form: {
        id: 0,
        name: '',
        client_id: 0,
        document_type:'',
        document:'',
        address:'',
        phone: '',
        email: '',
        observation: '',
        status: 0,
        type: 'production',
      },
      data: {},
      modal: {
        id: 0,
        remission_id: 0,
        model_id: 0,
        quantity: 0,
        price: 0,
        iva: 0,
        total: 0
      },
      modalEvidencia: [],
      suppliers: [],
      filteredSuppliers: [],
      clients: [],
      clientModal: null,
      newClient: {
        id: 0,
        name: '',
        document_type: '',
        document: '',
        address: '',
        phone: '',
        email: '',
        role: '4', // Cliente
        status: '1',
        password: 'cliente123',
        password_confirmation: 'cliente123',
        payment: '0',
        processes: [],
      },
    };
  },
  components: { ArgonInput, ArgonButton, ArgonTextarea },
  computed: {
    formattedPrice: {
      get() {
        return this.modal.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.modal.price = parseInt(value.replace(/\./g, "") || 0);
        this.updateModalLineTotal();
      },
    },
    totalPrice: {
      get() {
        return this.modal.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.modal.total = Math.floor(value.replace(/\./g, "") || 0);
        const quantity = parseFloat(this.modal.quantity) || 0;
        const ivaRate = (parseFloat(this.modal.iva) || 0) / 100;
        const divisor = quantity > 0 ? quantity * (1 + ivaRate) : 0;
        this.modal.price = divisor > 0 ? Math.floor(this.modal.total / divisor) : 0;
      },
    },
  },
  watch: {
    'modal.quantity'() {
      this.updateModalLineTotal();
    },
  },
  methods: {
    updateModalLineTotal() {
      const price = parseFloat(this.modal.price) || 0;
      const quantity = parseFloat(this.modal.quantity) || 0;
      const ivaRate = (parseFloat(this.modal.iva) || 0) / 100;
      this.modal.total = Math.floor(price * quantity * (1 + ivaRate));
    },

    /** Valores numéricos con formato es-CO (como en plantilla Excel de la imagen). */
    formatExcelCurrency(value) {
      const n = parseFloat(value) || 0;
      return n.toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    escapeExcelCell(raw) {
      if (raw == null || raw === '') {
        return '';
      }
      return String(raw).replace(/\t/g, ' ').replace(/\r?\n/g, ' ').trim();
    },

    buildRemissionDetailExportHeader() {
      const cells = [
        'Producto', 'Descripcion', 'Lote', 'Cantidad', 'Unidad',
        'Precio', 'Descuento', 'Cod IVA', 'Remisión', 'Precio Ref',
      ];
      return cells.join('\t');
    },

    /**
     * Una fila TSV en el orden de columnas de la plantilla contable.
     * Producto = ref | Descripcion = vacío | Lote = talla + " " + color |
     * Cantidad | Unidad = UN | Precio | Descuento = vacío |
     * Cod IVA = 19 | Remisión = vacío | Precio Ref = vacío
     */
    buildRemissionDetailExportRow(value) {
      const pm = value.production_model || {};
      const model = pm.model || value.model || {};
      const size = pm.size || {};
      const color = size.color || {};
      const qty = parseFloat(value.quantity) || 0;
      const price = parseFloat(value.price) || 0;

      const productoRef = model.ref ?? '';
      const talla = size.size ?? '';
      const colorName = color.name ?? '';
      const lote = `${talla} ${colorName}`.trim();

      const cells = [
        this.escapeExcelCell(productoRef),
        '',
        this.escapeExcelCell(lote),
        String(qty),
        'UN',
        this.formatExcelCurrency(price),
        '',
        '19',
        '',
        '',
      ];

      return cells.join('\t');
    },

    async copyDetailsForExcel() {
      const rows = this.data?.data;
      if (!Array.isArray(rows) || rows.length === 0) {
        await Swal.fire({
          icon: 'info',
          title: 'Sin ítems',
          text: 'No hay líneas en esta remisión para copiar.',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      const out = [this.buildRemissionDetailExportHeader()];
      rows.forEach((row) => {
        out.push(this.buildRemissionDetailExportRow(row));
      });
      const tsv = out.join('\n');

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(tsv);
        } else {
          const ta = document.createElement('textarea');
          ta.value = tsv;
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
        // Marcar la remisión como copiada en el backend antes de mostrar el Swal
        if (this.form.id && this.form.id != 0) {
          try {
            await this.$store.dispatch('remissions/markCopied', this.form.id);
            this.form.copied_at = new Date().toISOString();
          } catch (e2) {
            console.error('No se pudo marcar la remisión como copiada:', e2);
          }
        }

        await Swal.fire({
          icon: 'success',
          title: 'Copiado',
          text: 'Datos listos para pegar en Excel (Ctrl+V).',
          timer: 2200,
          showConfirmButton: false,
        });
      } catch (e) {
        await Swal.fire({
          icon: 'error',
          title: 'No se pudo copiar',
          text: 'El navegador bloqueó el portapapeles o no hay permisos HTTPS.',
          confirmButtonText: 'Aceptar',
        });
      }
    },

    mergeSeedClientsIntoList(seedRows) {
      const list = seedRows.filter(Boolean);
      for (const row of list) {
        const id = Number(row.id ?? row.user_id ?? 0);
        if (!id) {
          continue;
        }
        if (this.clients.some((c) => Number(c.id) === id)) {
          continue;
        }
        this.clients.push({
          id,
          name: row.name || '',
          email: row.email || '',
          phone: row.phone || '',
          address: row.address || '',
          document: row.document || '',
          document_type: row.document_type || '',
          role: row.role != null ? row.role : '4',
        });
      }
    },

    /**
     * Igual espíritu que `/purchases/create` (proveedor): armar opciones en Select2 y luego fijar valor.
     * Los usuarios de `seedClients` se fusionan **antes** de inicializar Select2 (si se añaden después,
     * Select2 no los refleja bien).
     *
     * @param {{ forceRebuild?: boolean, seedClients?: object[] }} opts
     */
    async getClients(opts = {}) {
      const forceRebuild = opts.forceRebuild === true;
      const seedClients = Array.isArray(opts.seedClients) ? opts.seedClients : [];

      try {
        const response = await this.$store.dispatch('users/getAll');
        let users = [];

        if (Array.isArray(response)) {
          users = response;
        } else if (response && response.data) {
          if (Array.isArray(response.data)) {
            users = response.data;
          } else if (response.data.data && Array.isArray(response.data.data)) {
            users = response.data.data;
          }
        }

        this.clients = users.filter(
          (user) => (user.role == '4' || user.role === 4)
            && String(user.name || '').toLowerCase().includes('kaybu'),
        );

        this.mergeSeedClientsIntoList(seedClients);

        await new Promise((resolve) => {
          this.$nextTick(() => {
            try {
              const select = $(this.$refs.clientSelect);
              if (!select.length) {
                return;
              }

              if (select.hasClass('select2-hidden-accessible')) {
                if (!forceRebuild) {
                  if (this.form.client_id > 0) {
                    this.refreshClientSelect2Value(this.form.client_id);
                  }
                  return;
                }
                select.select2('destroy');
              }

              select.empty();
              /* Sin disabled+selected por defecto: Select2 suele aplicar mejor .val(...) al editar */
              select.append('<option value=""></option>');

              this.clients.forEach((client) => {
                const displayText = `${client.name} - ${client.email || client.phone || ''}`;
                select.append(new Option(displayText, String(client.id), false, false));
              });

              select
                .select2({
                  placeholder: 'Seleccione un cliente',
                  allowClear: true,
                  width: '100%',
                })
                .off('change.select2-remission')
                .on('change.select2-remission', () => {
                  const selectedId = select.val();
                  if (selectedId) {
                    const selectedClient = this.clients.find(
                      (c) => String(c.id) === String(selectedId),
                    );
                    if (selectedClient) {
                      this.form.client_id = Number(selectedClient.id);
                      this.form.name = selectedClient.name;
                      this.form.email = selectedClient.email || '';
                      this.form.phone = selectedClient.phone || '';
                      this.form.address = selectedClient.address || '';
                      this.form.document = selectedClient.document || '';
                      this.form.document_type = selectedClient.document_type || '';
                    } else {
                      this.form.client_id = Number(selectedId) || 0;
                    }
                  } else {
                    this.form.client_id = 0;
                    this.form.name = '';
                    this.form.email = '';
                    this.form.phone = '';
                    this.form.address = '';
                    this.form.document = '';
                    this.form.document_type = '';
                  }
                  this.syncClientSelect2Display();
                });

              if (this.form.client_id > 0) {
                this.refreshClientSelect2Value(this.form.client_id);
              }
            } finally {
              resolve();
            }
          });
        });
      } catch (error) {
        console.error('Error al obtener clientes:', error);
      }
    },

    /** Si `user_id` viene vacío en el listado, infiere cliente ya cargado en `this.clients`. */
    inferClientIdFromRemissionRow(parsed) {
      if (Number(this.form.client_id) > 0) {
        return;
      }

      const direct =
        Number(parsed?.user_id ?? parsed?.client_id ?? parsed?.user?.id ?? 0) || 0;
      if (direct) {
        this.form.client_id = direct;
        return;
      }

      const emailNorm = String(
        parsed?.email || this.form.email || '',
      )
        .trim()
        .toLowerCase();
      if (emailNorm) {
        const byEmail = this.clients.find(
          (c) => String(c.email || '').trim().toLowerCase() === emailNorm,
        );
        if (byEmail?.id != null) {
          this.form.client_id = Number(byEmail.id);
          return;
        }
      }

      const doc = String(parsed?.document || this.form.document || '').trim();
      const docType = String(
        parsed?.document_type || this.form.document_type || '',
      )
        .trim()
        .toUpperCase();
      if (doc) {
        const byDoc = this.clients.find((c) => {
          const sameDoc =
            String(c.document || '').trim() === doc &&
            String(c.document_type || '').trim().toUpperCase() === docType;
          return (
            sameDoc ||
            (!docType && String(c.document || '').trim() === doc)
          );
        });
        if (byDoc?.id != null) {
          this.form.client_id = Number(byDoc.id);
        }
      }
    },

    /**
     * Select2 en flex (p. ej. 4.x RC) a veces deja `.select2-selection__rendered` sin texto aunque
     * el `<select>` tiene `value`; forzamos el texto desde la opción seleccionada.
     */
    syncClientSelect2Display() {
      this.$nextTick(() => {
        const select = $(this.$refs.clientSelect);
        if (!select.length || !select.hasClass('select2-hidden-accessible')) {
          return;
        }
        const v = select.val();
        if (v == null || v === '') {
          return;
        }
        const vStr = String(v);
        let label = '';
        select.find('option').each(function () {
          if (String(this.value) === vStr) {
            label = (this.textContent || '').trim();
            return false;
          }
        });
        if (!label) {
          label = `#${vStr}`;
        }
        const container = select.next('.select2-container');
        if (!container.length) return;
        container.css({ width: '100%', maxWidth: '100%' });
        container.find('.select2-selection').css({ width: '100%' });
        const rendered = container.find('.select2-selection__rendered');
        if (!rendered.length) return;
        rendered.text(label);
        rendered.attr('title', label);
      });
    },

    /**
     * Asegura opción Select2 si falta el ID en la lista actual y fuerza valor + etiqueta visible.
     */
    refreshClientSelect2Value(cid) {
      const id = Number(cid) || 0;
      const select = $(this.$refs.clientSelect);
      if (!this.$refs.clientSelect || id <= 0 || !select.length) {
        return;
      }

      const idStr = String(id);
      if (!select.find(`option[value="${idStr}"]`).length && !select.find(`option[value="${id}"]`).length) {
        const label =
          `${this.form.name || 'Cliente'} - ${this.form.email || this.form.phone || idStr}`;
        select.append(new Option(label, idStr, false, false));
        if (
          !this.clients.some((c) => Number(c.id) === id)
        ) {
          this.clients.push({
            id,
            name: this.form.name,
            email: this.form.email || '',
            phone: this.form.phone || '',
            address: this.form.address || '',
            document: this.form.document || '',
            document_type: this.form.document_type || '',
            role: '4',
          });
        }
      }

      select.val(idStr).trigger('change');
      this.syncClientSelect2Display();
    },

    applyRemissionToForm(r) {
      this.form.id = r.id || 0;
      this.form.name = r.name || '';
      this.form.client_id = Number(r.user_id ?? r.client_id ?? r.user?.id ?? 0) || 0;
      this.form.document_type = r.document_type || '';
      this.form.document = r.document || '';
      this.form.address = r.address || '';
      this.form.phone = r.phone || '';
      this.form.email = r.email || '';
      this.form.type = r.type || 'production';
      this.form.observation = r.observation || '';
      this.form.status =
        typeof r.status === 'string' ? parseInt(r.status, 10) || 0 : r.status ?? 0;
      this.modal.remission_id = r.id || 0;
    },
    openClientModal() {
      // Resetear el formulario del nuevo cliente
      this.newClient = {
        id: 0,
        name: '',
        document_type: '',
        document: '',
        address: '',
        phone: '',
        email: '',
        role: '4',
        status: '1',
        password: 'cliente123',
        password_confirmation: 'cliente123',
        payment: '0',
        processes: [],
      };
      
      const modalElement = document.getElementById('ModalClient');
      this.clientModal = new Modal(modalElement);
      this.clientModal.show();
    },
    closeClientModal() {
      if (this.clientModal) {
        this.clientModal.hide();
      }
    },
    async saveClient() {
      try {
        // Validar campos requeridos
        if (!this.newClient.name || !this.newClient.email || !this.newClient.phone) {
          await Swal.fire({
            icon: 'warning',
            title: 'Campos requeridos',
            text: 'Por favor complete todos los campos obligatorios.',
            confirmButtonText: 'Aceptar'
          });
          return;
        }
        
        // Crear el cliente en usuarios
        const response = await this.$store.dispatch('users/save', this.newClient);
        
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El cliente ha sido registrado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });
          
          await this.getClients({ forceRebuild: true });

          this.$nextTick(() => {
            if (response.data.id) {
              this.refreshClientSelect2Value(response.data.id);
            }
          });
          
          this.closeClientModal();
        } else {
          throw new Error(response.data?.message || 'Error al guardar el cliente');
        }
      } catch (error) {
        console.error("Error al crear el cliente:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al guardar el cliente',
        });
      }
    },
    async getModels() {
      this.$nextTick(() => {
        const select = $(this.$refs.ModelSelect);

        if (select.hasClass("select2-hidden-accessible")) {
          select.select2('destroy');
        }
        select.empty();
        select.append('<option value="" disabled selected>Buscar modelo...</option>');

        // Cache local de productos cargados vía AJAX
        this.models = { data: [] };

        const formatOption = (prod) => {
          const ref = prod.model?.ref || 'Sin ref';
          const talla = prod.size?.size || 'N/A';
          const color = prod.size?.color?.name || 'N/A';
          const stock = prod.stock != null ? prod.stock : 0;
          const produccionName = prod.production?.name || prod.production?.model?.name || 'Sin nombre';
          return {
            id: String(prod.id),
            text: `${ref} - ${talla} - ${color} - STOCK: ${stock}\n${produccionName}`,
            prod,
          };
        };

        $(this.$refs.ModelSelect).select2({
          placeholder: 'Buscar modelo por ref, talla, color o producción...',
          allowClear: false,
          minimumInputLength: 2,
          dropdownParent: $('#ModalBudget .modal-body'),
          language: {
            inputTooShort: () => 'Ingrese 2 o más caracteres',
            noResults: () => 'No se encontraron resultados',
            searching: () => 'Buscando...',
            loadingMore: () => 'Cargando más resultados...',
          },
          ajax: {
            delay: 400,
            transport: (params, success, failure) => {
              const queryParams = new URLSearchParams();
              queryParams.append('search', params.data.search || '');
              queryParams.append('page', params.data.page || 1);
              queryParams.append('production_status', '2');
              const url = `${process.env.VUE_APP_API_BASE_URL}/production-model?${queryParams.toString()}`;
              axios.get(url, { headers: authHeader() })
                .then((response) => success(response.data))
                .catch(failure);
            },
            processResults: (resp) => {
              const items = (resp && resp.data) ? resp.data : [];
              const withStock = items.filter(prod => parseFloat(prod.stock || 0) > 0);
              // Guardar en cache local para el handler change
              withStock.forEach(prod => {
                if (!this.models.data.find(p => p.id === prod.id)) {
                  this.models.data.push(prod);
                }
              });
              const results = withStock.map(prod => {
                const opt = formatOption(prod);
                return { id: opt.id, text: opt.text };
              });
              return {
                results,
                pagination: { more: (resp.current_page || 1) < (resp.last_page || 1) },
              };
            },
            cache: true,
          },
          templateResult: (state) => {
            if (!state.id) return state.text;
            return $('<span style="white-space: pre-line; line-height: 1.3;"></span>').text(state.text);
          },
          templateSelection: (state) => {
            if (!state.id) return state.text;
            return $('<span style="white-space: pre-line; line-height: 1.3;"></span>').text(state.text);
          },
        });

        $(this.$refs.ModelSelect).on('change', () => {
          this.modal.model_id = $(this.$refs.ModelSelect).val();

          const selectedModel = this.models.data.find(prod => String(prod.id) === String(this.modal.model_id));

          if (selectedModel) {
            // Usar el precio de venta (selling_cost) de la producción si existe
            this.modal.price = parseFloat(selectedModel.production?.selling_cost || selectedModel.production?.price || selectedModel.price || 0);

            if(this.modal.id==0){
              // Establecer la cantidad inicial en 1 por defecto
              this.modal.quantity = 1;
            }

           this.updateModalLineTotal();
          }
        });
      });
    },
    addDetail() {
      this.modal.id = 0;
      this.modal.remission_id = this.form.id; // Establecer el ID de la remisión
      this.modal.production_id = 0;
      this.modal.model_id = 0;
      this.modal.quantity = 0;
      this.modal.price = 0;
      this.modal.iva = 0;
      this.modal.total = 0;

      // Verificar que la remisión tenga un ID
      if (!this.form.id || this.form.id === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe guardar la remisión primero antes de agregar productos.',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      this.getModels();
      $(this.$refs.ModelSelect).val("").trigger('change');

      this.openModal();
    },
    openModal() {
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
    },
    async getData() {
      this.data = await this.$store.dispatch('remissionsDetails/getData', this.form.id);
    },
    async confirm() {
      // Verificar que la remisión tenga un ID
      if (!this.form.id || this.form.id === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe guardar la remisión primero antes de formalizarla.',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      // Verificar que tenga detalles
      if (!this.data.data || this.data.data.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe agregar al menos un producto antes de formalizar la remisión.',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      const result = await Swal.fire({
        icon: 'info',
        title: 'Formalizar remisión',
        text: 'Al formalizar la remisión se restará la cantidad del stock disponible en los productos de producción. Ya no se podrá editar los registros ni los detalles de la remisión.',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        backdrop: true,
      });

      if (result.isConfirmed) {
        try {
          const response = await this.$store.dispatch("remissions/formalize", this.form.id);
          
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'La remisión ha sido formalizada correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
            }).then(() => {
              // Actualizar el estado del formulario
              this.form.status = 1;
              // Recargar los datos para reflejar los cambios
              this.getData();
            });
          } else {
            throw new Error(response.data?.message || 'Error al formalizar la remisión');
          }
        } catch (error) {
          console.error("Error al formalizar la remisión:", error);
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || error.message || 'Error al formalizar la remisión',
            confirmButtonText: 'Aceptar'
          });
        }
      }
    },
    async save() {
      try {
        if (this.$refs.clientSelect) {
          const selected = $(this.$refs.clientSelect).val();
          if (selected) {
            this.form.client_id = Number(selected) || 0;
          }
        }

        // Si hay datos de contacto pero aún no hay cliente (user_id), intentar emparejar o crear usuario
        if (this.form.name && this.form.client_id == 0) {
          // Verificar si el cliente ya existe por email o nombre
          const existingClient = this.clients.find(c => 
            c.email === this.form.email || c.name === this.form.name
          );
          
          if (!existingClient && this.form.email && this.form.name) {
            // Crear el cliente en usuarios
            const clientData = {
              id: 0,
              name: this.form.name,
              email: this.form.email,
              phone: this.form.phone || '',
              address: this.form.address || '',
              document_type: this.form.document_type || 'CC',
              document: this.form.document || '',
              role: '4', // Cliente
              status: '1',
              password: 'cliente123',
              password_confirmation: 'cliente123',
              payment: '0',
              processes: [],
            };
            
            const clientResponse = await this.$store.dispatch('users/save', clientData);
            
            if (clientResponse && clientResponse.status >= 200 && clientResponse.status < 300) {
              this.form.client_id = clientResponse.data.id;
              // Recargar la lista de clientes
              await this.getClients({ forceRebuild: true });
            }
          } else if (existingClient) {
            this.form.client_id = existingClient.id;
          }
        }

        if (!Number(this.form.client_id)) {
          await Swal.fire({
            icon: 'warning',
            title: 'Cliente requerido',
            text: 'Seleccione un cliente en el campo Cliente antes de guardar.',
            confirmButtonText: 'Aceptar',
          });
          return;
        }

        // Dispara la acción de Vuex para guardar la remisión
        const response = await this.$store.dispatch("remissions/save", this.form);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.form = response.data;
              this.form.id = response.data.id || 0;
              this.form.client_id = Number(response.data.user_id ?? response.data.client_id ?? 0) || 0;
              
              // Actualizar el remission_id en el modal si está abierto
              if (this.modal.remission_id === 0) {
                this.modal.remission_id = this.form.id;
              }
              
              // Si se formalizó, recargar los datos
              if (this.form.status === 1) {
                this.getData();
              }

              this.$nextTick(() => {
                if (Number(this.form.client_id) > 0) {
                  this.refreshClientSelect2Value(this.form.client_id);
                }
              });

            }
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async submitForm() {
      try {

        const selectedModel = this.models.data.find(prod => prod.id == this.modal.model_id );

        if (this.modal.quantity > selectedModel.stock) {
          Swal.fire({
            icon: 'warning',
            title: 'Cantidad excedida',
            text: 'La cantidad ingresada supera el stock disponible.',
            confirmButtonText: 'Aceptar'
          });
          return; // detener ejecución si quieres evitar continuar
        }
        // Dispara la acción de Vuex para guardar el modal
        const response = await this.$store.dispatch("remissionsDetails/save", this.modal);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.modal.id = 0;
              this.modal.production_id = 0;
              this.modal.model_id = 0;
              this.modal.quantity = 0;
              this.modal.price = 0;
              this.modal.iva = 0;
              this.modal.total = 0;

              $(this.$refs.processesSelect).val('').trigger('change');

              this.getData();
              this.closeModal();
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    async editRegister(params) {
      this.modal.id = params.id;
      this.modal.remission_id = params.remission_id ?? this.form.id ?? 0;
      this.modal.model_id = params.production_models_id;
      this.modal.quantity = params.quantity;
      this.modal.price = parseFloat(params.price) || 0;
      this.modal.iva = parseFloat(params.iva) || 0;
      this.modal.total = parseFloat(params.total) || 0;

      this.openModal();

      await new Promise(resolve => setTimeout(resolve, 500));

      // Con Select2 AJAX, la opción no existe hasta que se busca.
      // Inyectamos manualmente la opción usando los datos del detalle.
      const pm = params.production_model || {};
      const model = pm.model || params.model || {};
      const size = pm.size || {};
      const color = size.color || {};
      const ref = model.ref || 'Sin ref';
      const talla = size.size || 'N/A';
      const colorName = color.name || 'N/A';
      const stock = pm.stock != null ? pm.stock : 0;
      const produccionName = pm.production?.name || pm.production?.model?.name || params.produccion?.name || 'Sin nombre';
      const displayText = `${ref} - ${talla} - ${colorName} - STOCK: ${stock}\n${produccionName}`;

      // Guardar el producto en el cache local para el handler change
      if (!this.models.data.find(p => String(p.id) === String(this.modal.model_id))) {
        this.models.data.push({
          id: this.modal.model_id,
          model,
          size,
          production: pm.production || { name: produccionName },
          production_models_id: this.modal.model_id,
          price: this.modal.price,
          stock,
        });
      }

      const select = $(this.$refs.ModelSelect);
      const existingOption = select.find(`option[value="${this.modal.model_id}"]`);
      if (existingOption.length === 0) {
        select.append(new Option(displayText, String(this.modal.model_id), true, true));
      }
      select.val(String(this.modal.model_id)).trigger('change');

      this.$nextTick(() => {
        this.modal.quantity = params.quantity;
        this.modal.price = parseFloat(params.price) || 0;
        this.modal.iva = parseFloat(params.iva) || 0;
        this.updateModalLineTotal();
      });
    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("remissionsDetails/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async updateDetailQuantity(value, newQuantity) {
      const qty = parseInt(newQuantity);
      if (isNaN(qty) || qty < 1) {
        await Swal.fire({
          icon: 'warning',
          title: 'Cantidad inválida',
          text: 'La cantidad debe ser un número entero mayor o igual a 1.',
          confirmButtonText: 'Aceptar',
        });
        this.getData();
        return;
      }

      if (qty === parseInt(value.quantity)) {
        return;
      }

      try {
        const payload = {
          id: value.id,
          remission_id: value.remission_id ?? this.form.id ?? 0,
          model_id: value.production_models_id,
          quantity: qty,
          price: parseFloat(value.price) || 0,
          iva: parseFloat(value.iva) || 0,
        };

        const response = await this.$store.dispatch("remissionsDetails/save", payload);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Actualizado!',
            text: 'La cantidad se actualizó correctamente.',
            timer: 1500,
            showConfirmButton: false,
          });
          this.getData();
        } else {
          throw new Error(response?.data?.message || 'Error al actualizar la cantidad');
        }
      } catch (error) {
        console.error("Error al actualizar la cantidad:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al actualizar la cantidad',
        });
        this.getData();
      }
    },
    async printRemission(id) {
      try {
        const response = await this.$store.dispatch("remissions/getPdf", id);
        
        // Crear una URL del archivo recibido
        const url = window.URL.createObjectURL(new Blob([response.data]));
        
        // Crear un enlace para descargar el archivo
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Remision_${id}.pdf`); // Nombre del archivo
        document.body.appendChild(link);
        link.click();
        
        // Limpiar la URL creada
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
      } catch (error) {
        console.error("Error al generar el PDF:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'Error al generar el PDF de la remisión',
        });
      }
    },
  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem('user'));
    const route = useRoute();
    const dataEdit = route.params.data;

    let parsedEdit = null;
    /** Incluir el `user_id` de la remisión **antes** de crear Select2 (rol ≠ clientes, usuarios cargados después, etc.). */
    const seedClients = [];

    if (dataEdit) {
      try {
        parsedEdit = JSON.parse(dataEdit);
      } catch (error) {
        console.error('Error al parsear remisión (params.data):', error);
      }
    }

    /*
     * Recomponer objeto como en servidor: las filas del listado pueden no traer bien `user_id`.
     */
    if (parsedEdit?.id) {
      try {
        const res = await this.$store.dispatch(
          'remissions/getData',
          parsedEdit.id,
        );
        const apiRow = res?.data;
        if (apiRow && typeof apiRow === 'object') {
          parsedEdit = { ...parsedEdit, ...apiRow };
        }
      } catch (error) {
        console.warn(
          'No se pudo refrescar la remisión por API para select de cliente:',
          error,
        );
      }
    }

    if (parsedEdit?.id) {
      const uid =
        Number(
          parsedEdit.user_id ??
            parsedEdit.client_id ??
            parsedEdit.user?.id ??
            0,
        ) || 0;
      if (uid) {
        if (parsedEdit.user && parsedEdit.user.id != null) {
          seedClients.push(parsedEdit.user);
        } else {
          seedClients.push({
            id: uid,
            name: parsedEdit.name,
            email: parsedEdit.email,
            phone: parsedEdit.phone,
            address: parsedEdit.address,
            document: parsedEdit.document,
            document_type: parsedEdit.document_type,
            role: parsedEdit.role ?? '4',
          });
        }
      }
    }

    await new Promise((resolve) => this.$nextTick(resolve));
    await this.getClients({ forceRebuild: true, seedClients });

    if (parsedEdit && parsedEdit.id) {
      this.data = parsedEdit;
      this.applyRemissionToForm(parsedEdit);
      this.inferClientIdFromRemissionRow(parsedEdit);

      await this.$nextTick();
      await this.$nextTick();

      if (Number(this.form.client_id) > 0) {
        this.refreshClientSelect2Value(this.form.client_id);
      }

      await this.getData();
      this.getModels();

      this.$nextTick(() => {
        if (Number(this.form.client_id) > 0) {
          this.refreshClientSelect2Value(this.form.client_id);
        }
      });
    }
    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}

/* Select2 del modal de productos: mostrar dos líneas (ref-talla-color-stock / producción) */
.select2-results__option {
  white-space: pre-line !important;
  line-height: 1.3;
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
  white-space: pre-line !important;
  line-height: 1.3;
}
</style>
